import ApiService from "./api.service";

const PacienteService = {
  async getPacientes(params) {
    return await ApiService.get("/pacientes", params);
  },

  async getPaciente(cpf) {
    return await ApiService.get(`/pacientes/buscar-por-cpf/${cpf}`);
  },

  async salvar(paciente) {
    return await ApiService.post("/pacientes/salvar", paciente);
  },
};

export default PacienteService;
